import { AbstractControl, ValidationErrors } from '@angular/forms';

export function siteKeyValidatorFn(control: AbstractControl): ValidationErrors | null {
  const isValid = control.value ? control.value.match(/^\d*[a-zA-Z][a-zA-Z0-9]*$/) : true;
  return isValid ? null : { invalidSiteKey: true };
}
